module.exports = __webpack_public_path__ + "img/rs.6e843b9e.svg";